let config = {
    appName: '威视安培云',
    version: '2.5',

    // baseUrl: process.env.VUE_APP_BASE_URL,                    //api服务
    // wsURL: process.env.VUE_APP_WS_URL,                        //signalR
    // homeUrl: process.env.VUE_APP_HOME_URL,                    //门户
    // mobileUrl: process.env.VUE_APP_MOBILE_URL,                //m站
    // mobileStudyUrl: process.env.VUE_APP_MOBILE_STUDY_URL,      //移动端主动学习api
    // imagePanoramicHost: process.env.VUE_APP_IMAGE_PANORAMIC_HOST //图像全景台网站地址

    /**
     * 开发
     */
    // baseUrl: 'https://devapi.anjianba.cn', //api服务
    // wsURL: 'https://devws.anjianba.cn', //signalR
    // homeUrl:'https://dev.anjianba.cn', //门户
    // mobileUrl:'https://devm.anjianba.cn', //m站
    // mobileStudyUrl: 'https://devmapi.anjianba.cn', //移动端主动学习api
    // imagePanoramicHost: 'https://devpano.anjianba.cn' //图像全景台网站地址

    /**
     * 测试
     */
    // baseUrl: 'https://stgapi.anjianba.cn', //api服务
    // wsURL: 'https://stgws.anjianba.cn',    //signalR
    // homeUrl:'https://stg.anjianba.cn', //门户
    // mobileUrl:'https://stgm.anjianba.cn', //m站
    // mobileStudyUrl: 'https://stgmapi.anjianba.cn', //移动端主动学习api
    // imagePanoramicHost: 'https://stgpano.anjianba.cn' //图像全景台网站地址

    /**
     * 生产
     */
    baseUrl: 'https://api2.anjianba.cn', //api服务
    wsURL: 'https://ws.anjianba.cn',    //signalR
    homeUrl:'https://www.anjianba.cn', //门户
    mobileUrl:'https://m.anjianba.cn', //m站
    mobileStudyUrl: 'https://mapi.anjianba.cn', //移动端主动学习api
    imagePanoramicHost: 'https://pano.anjianba.cn' //图像全景台网站地址
};

window.APIURI = config.baseUrl+'/';
localStorage.setItem('app_api_url', config.baseUrl + '/')
localStorage.setItem('mobile_url', config.mobileUrl + '/')
localStorage.setItem('pre_job_url', config.mobileStudyUrl + '/')
localStorage.setItem('app_version', config.version)

module.exports = config;
